module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('router-link', {
    style: ({
      backgroundColor: _vm.getBrandColor
    }),
    attrs: {
      "to": _vm.to,
      "exact": ""
    }
  }, [_vm._v(_vm._s(_vm.text) + " >")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7a2b0a4f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/elements/LinkButton.vue
// module id = 3283
// module chunks = 0